import { useStag } from 'hooks/stag';
import { createContext, FC } from 'react';

interface StagContextData {
  isStag: boolean;
}

export const StagContext = createContext<StagContextData>(null as any);

export const StagContextProvider: FC = ({ children }) => {
  const { isStag } = useStag();

  return (
    <StagContext.Provider value={{ isStag }}>{children}</StagContext.Provider>
  );
};
